module.exports = __webpack_public_path__ + "img/blank-favorite.e8a72dd5.svg";